import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../Auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { serverUrl } from '../Constant/Static/config';
import Loader from '../Constant/Custom/Loader';
import VerifierSideBar from './Components/VerifierSideBar';
import { Routes, Route } from 'react-router-dom';
import TNLogo from '../Constant/Icons/TamilNadu_Logo.png';
import logoutIcon from '../Constant/Icons/logout.svg';
import VerifierHome from './VerifierHome';
import Window from './Services/Window';
import axios from 'axios';
import './cv.css';
import SessionTimer from '../Auth/SessionTimer';


function VerifierDashboard() {
    const { auth, logoutVerifier } = useContext(AuthContext);
    const storedUser = auth?.user || null;
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logoutVerifier();
            setUser(null);
            navigate('/cv/login');
        } catch (error) {
            console.error('Logout failed', error);
        }
    };

    useEffect(() => {
        const fetchUserAndStatus = async () => {
            if (!auth.isVerifierAuthenticated) return; // Prevents running before auth is ready
            // console.log('Stored User:', storedUser);
            if (storedUser?.userInfo) {
                try {
                    const response = await axios.post(`${serverUrl}/api/cv/verifier/get-verifier`, {
                        user_id: storedUser.userInfo?.USER_ID || storedUser.userInfo?.verifier_id,
                        mobile: storedUser.userInfo?.MOBILE,
                        email: storedUser.userInfo?.EMAIL
                    });
                    setUser(response.data.verifier);
                } catch (err) {
                    console.error('Error fetching status:', err);
                } finally {
                    setLoading(false);
                }
            } else {
                setTimeout(() => navigate('/cv/login'), 100);
            }
        };

        fetchUserAndStatus();
    }, [auth.isVerifierAuthenticated, navigate]);

    useEffect(() => {
        const handleReload = () => {
            if (!auth.isVerifierAuthenticated) {
                navigate('/cv/login');
            }
        };

        window.addEventListener('beforeunload', handleReload);

        return () => {
            window.removeEventListener('beforeunload', handleReload);
        };
    }, [auth.isVerifierAuthenticated, navigate]);




    if (loading) {
        return <Loader />;
    }

    return (
        <SessionTimer handleLogout={handleLogout}>
            <div className='app'>
                <VerifierSideBar onRouteChange={navigate} />
                <div className='content'>
                    <div className="header">
                        <div>
                            <img alt='TN' src={TNLogo} width={50} height={50} />
                        </div>
                        <div className='header-content'>
                            <h3>GOVERNMENT OF TAMILNADU</h3>
                            <h4>Tamilnadu Lateral Entry Direct Second Year B.E/B.Tech., Admissions - 2026</h4>
                        </div>
                        <div>
                            <button className='button' onClick={handleLogout}>
                                <img alt='Logout' src={logoutIcon} width={30} height={30} />
                            </button>
                        </div>
                    </div>

                    <Routes>
                        <Route path="/" element={<VerifierHome userDetail={user} />} />
                        <Route path="/verification-window" element={<Window userInfo={user} />} />
                    </Routes>
                </div>
            </div>
        </SessionTimer>
    )
}

export default VerifierDashboard;